import React, { useEffect } from 'react';
import { useLocation, Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import LocalBusinessSchema from '../SchemaMarkup';

const Layout = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      // Wait for lazy-loaded page content to render before scrolling
      const timer = setTimeout(() => {
        const el = document.querySelector(location.hash);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 300);
      return () => clearTimeout(timer);
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <div className="flex flex-col min-h-screen">
      <a href="#main-content" className="skip-link">
        Přeskočit na hlavní obsah
      </a>
      <Header />
      <LocalBusinessSchema />
      <main id="main-content" className="flex-grow">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
